import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../api/client';

const SettingsContext = createContext({ settings: null, loading: true, reload: () => {} });

// Sensible defaults so the shell renders before the API responds.
const DEFAULTS = {
  general: { siteName: 'ELEGEEK', logo: '/logo.png', logoWidth: 170, favicon: '/favicon.png' },
  announcement: { enabled: false, text: '' },
  header: { menu: [], popularSearches: [], showSearch: true, showWishlist: true, showAccount: true },
  footer: { columns: [], newsletterText: '', bottomText: '', paymentIcons: [] },
  social: {},
  shop: { currency: 'USD', currencySymbol: '$', freeShippingOver: 0, shippingFlatRate: 0, codEnabled: true, mobileStickyBar: true },
  seo: {},
  pages: { blogSlug: 'news', blogTitle: 'NEWS', collectionTitle: 'Products' },
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(() => {
    setLoading(true);
    api
      .get('/settings')
      .then((res) => setSettings({ ...DEFAULTS, ...res.settings }))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return <SettingsContext.Provider value={{ settings, loading, reload }}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);
